import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/App";
import { 
  LayoutDashboard, 
  FileText, 
  Clock,
  Home,
  User,
  Music,
  Shield
} from "lucide-react";

const MobileBottomNav = () => {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) return null;

  const navItems = [
    { href: "/dashboard", label: "Accueil", icon: Home },
    { href: "/fiches", label: "Fiches", icon: FileText },
    { href: "/hymne", label: "Hymne", icon: Music },
    { href: "/exam", label: "Examen", icon: Clock },
  ];

  if (user.role === "admin") {
    navItems.push({ href: "/admin", label: "Admin", icon: Shield });
  }

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 md:hidden z-50 safe-area-bottom">
      <div className="flex justify-around items-center h-16">
        {navItems.map((item) => (
          <Link
            key={item.href}
            to={item.href}
            className={`flex flex-col items-center justify-center flex-1 h-full py-2 transition-colors ${
              isActive(item.href)
                ? "text-blue-900"
                : "text-slate-400"
            }`}
            data-testid={`mobile-nav-${item.label.toLowerCase()}`}
          >
            <item.icon className={`h-5 w-5 mb-1 ${isActive(item.href) ? "stroke-[2.5]" : ""}`} />
            <span className="text-xs font-medium">{item.label}</span>
            {isActive(item.href) && (
              <div className="absolute bottom-0 w-12 h-0.5 bg-blue-900 rounded-t-full"></div>
            )}
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
